@use '@fukuri-admins/ui/layout' as *;

.BottomNavMenu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: background('Primary');
  display: flex;
  border-top: 1px solid border('Tertiary');
  z-index: 999;

  &__Item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: text('Disabled');
    background: none;
    border: none;
    padding: 4px 0;

    &.active {
      color: text('Link');
    }
  }

  &__Icon {
    width: 24px;
    height: 24px;
  }

  &__Label {
    font-size: 10px;
    margin-top: 2px;
    white-space: pre;
  }
}
